/**
 * Mira assistant — context provider for the NLU assistant.
 * Migration target: S29 Mira assistant (256,396–264,489) + mira-knowledge.js (14,272 lines).
 * Maps to MTSS2RTI.html S29 NLU router, coaching engine, analysis pipeline.
 * Roadmap note: Mira has its own knowledge base in mira-knowledge.js. Intent routing is separate.
 * TODO: Export useMira, MiraChat, MiraCoach, MiraAnalysis and wrap children
 * in the real Mira context. Until then this provider is a pass-through — a
 * provider that swallows its children renders the whole app to nothing.
 */
import type { ReactNode } from 'react';

export const MiraProvider = ({ children }: { children: ReactNode }) => <>{children}</>;
